/**
 * ============================================================================
 * BAMBOOVE — KHỐI “SHOP BY STYLE” (port từ bản đã duyệt `v53`, khối 06)
 * ----------------------------------------------------------------------------
 * Một việc DUY NHẤT: CHUYỂN TAB (bấm chuột + bàn phím) ⇒ đổi panel đang hiện.
 * Đúng khuôn bản vẽ `v53` (mục “3 TAB chon nhom bo suu tap”):
 *   · bấm tab  ⇒ panel tương ứng hiện, các panel khác ẩn
 *   · bàn phím  ⇒ ← → nhảy tab kề · Home = tab đầu · End = tab cuối
 *   · ARIA      ⇒ aria-selected + tabindex theo WAI-ARIA Tabs Pattern
 * KHÔNG đụng gì khác: dải trượt · hút mốc · nút giỏ · chọn cỡ đã có
 * `assets/bamboove-bestsellers.js` lo (file đó bám `.bamboove-bs [data-bs-grid]`
 * nên khối này được dùng chung, không phải chép lại).
 * ============================================================================
 */
(function () {
  'use strict';

  var ROOT = '.bamboove-sbs';

  function chay(goc) {
    var tabs = [].slice.call(goc.querySelectorAll('[data-sbs-tab]'));
    var panels = [].slice.call(goc.querySelectorAll('[data-sbs-panel]'));
    if (!tabs.length || !panels.length) return;

    function bat(idx, layTieuDiem) {
      tabs.forEach(function (t, i) {
        var dang = i === idx;
        t.setAttribute('aria-selected', dang ? 'true' : 'false');
        t.setAttribute('tabindex', dang ? '0' : '-1');
        if (dang && layTieuDiem) t.focus();
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
    }

    /* đồng bộ trạng thái ngay khi tải trang (tab đang có sẵn `aria-selected` trong HTML) */
    var dau = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    bat(dau < 0 ? 0 : dau, false);

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { bat(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); bat(n, true); }
      });
    });
  }

  function tatCa() {
    document.querySelectorAll(ROOT).forEach(function (goc) {
      /* (13/10/2026 · p64) Dấu “đã gắn” phải KHÁC tên dấu của NÚT TAB.
         Bản cũ ghi `goc.dataset.sbsTab = '1'` ⇒ khối cha mang `data-sbs-tab="1"`,
         TRÙNG tên với `[data-sbs-tab]` của nút ⇒ bất kỳ đoạn mã nào chọn
         `document.querySelectorAll('[data-sbs-tab]')` cũng dính khối cha (đứng TRƯỚC
         các nút) ⇒ đánh số lệch 1 (đã làm công cụ đo của phiên 64 báo sai).
         Đổi tên thành `data-sbs-da-gan` cho khỏi trùng. */
      if (goc.dataset.sbsDaGan === '1') return;
      goc.dataset.sbsDaGan = '1';
      chay(goc);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tatCa);
  } else {
    tatCa();
  }
  /* trình soạn theme vẽ lại section ⇒ gắn lại cho section mới */
  document.addEventListener('shopify:section:load', function (e) {
    var goc = e && e.target ? e.target.querySelector(ROOT) : null;
    if (goc) chay(goc);
  });
})();
